/**
 * Tenant-keyed durable flag snapshot prefix; logout clears every key under it.
 *
 * A leaf module so `utils/logout.ts` can name it without importing
 * `useFeatureFlag`, whose own imports (`api/projectSettings` → `config/axios`)
 * lead back to `utils/logout.ts`.
 */
export const FEATURE_FLAG_STORAGE_KEY_PREFIX = "featureFlags.settings";
